// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Hero__Wrapper_3WGdU","Title":"Hero__Title_19sX5","Link":"Hero__Link_1wYn_","Description":"Hero__Description_2S8Au"};